import React from 'react';
import { Row, Col } from 'reactstrap';
import { getAccountDetails, getMyMemberships, getPaymentMethod, clearPayment } from '../../../../../Redux/Actions/EndUser/AccountDetailsActions';
import SubscriptionDetails from '../SubscriptionDetails/SubscriptionDetails';
import { auth } from '../../../../../services';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { provideIntlService } from '@progress/kendo-react-intl';
import AutoRenew from '../AutoRenew/AutoRenew';
import PaymentDetails from '../PaymentDetails/PaymentDetails';
import SpanSpinner from '../../../../Shared/SpanSpinner/SpanSpinner';
import './MembershipDetails.scss';

class MembershipDetails extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			paymentDetailsLoading: false,
			isPopupVisible: false,
			hasCanceledAutoRenew: false,
			paymentMethod: null,
			isOwner: false
		};
	}

	componentDidMount() {
		var membership = this.props.accountDetails.selectedMember;
		//console.log(membership);
		var isOwner = this.props.accountDetails.selectedMember.isOwner;
		var userId = auth.getAuthUserId();
		this.props.getMyMemberships(userId);
		this.setState({
			paymentDetailsLoading: true,
			isOwner: isOwner,
		});

		if (isOwner) {
			this.props.getPaymentMethod(this.props.accountDetails.selectedMember.membershipId);
		}
	}

	componentWillUnmount() {
		this.setState({
			isPopupVisible: false,
			paymentDetailsLoading: true,
		});
		this.props.clearPayment();
    }

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.details !== this.props.details) {
			this.setState({ details: this.props.details });
		}

		if (this.state.paymentDetailsLoading && this.props.paymentMethod != null && prevProps.paymentMethod != this.props.paymentMethod) {
			this.setState({
				paymentDetailsLoading: false,
				paymentMethod: this.props.paymentMethod
			});
        }

		if (prevProps.accountDetails.cancelAutoRenew === true && this.props.accountDetails.cancelAutoRenew === false) {
			this.setState({
				hasCanceledAutoRenew: true
			})
		}
	}

	close = () => {
		this.setState({
			isPopupVisible: false,
			paymentDetailsLoading: true,
			//paymentMethod: null
		});
		this.props.clearPayment();
		this.props.getPaymentMethod(this.props.accountDetails.selectedMember.membershipId);
	};

	render() {
		return (
			<div className="account-tab-content">
					<div>
						<div>
							<h1 className="pt-3 pb-3">Membership Details</h1>
						</div>
						<div className="card">
							<ul className="list-group list-group-flush dashboard-info-list">
								<li sm={{ size: 6, order: 2, offset: 1 }} className="list-group-item">
									<p>
										<span className="pr-2">Membership Number: </span>
									<strong className="dashboard-info-text">{this.props.accountDetails.selectedMember.memberNumber}</strong>
									</p>
								</li>
								<li sm={{ size: 6, order: 2, offset: 1 }} className="list-group-item">
									<p>
										<span className="pr-2">Organization Name: </span>
										<strong className="dashboard-info-text">{this.props.accountDetails.selectedMember.organizationName}</strong>
									</p>
								</li>
								<li sm={{ size: 6, order: 2, offset: 1 }} className="list-group-item">
									<p>
										<span className="pr-2">Membership Type: </span>
										<strong className="dashboard-info-text">{this.props.accountDetails.selectedMember.membershipType}</strong>
									</p>
								</li>
								<li sm={{ size: 6, order: 2, offset: 1 }} className="list-group-item">
									<p>
										<span className="pr-2">Membership Package: </span>
										<strong className="dashboard-info-text">{this.props.accountDetails.selectedMember.membershipPackage}</strong>
									</p>
								</li>
								<li sm={{ size: 6, order: 2, offset: 1 }} className="list-group-item">
									<p>
										<span className="pr-2">Last Renew Date: </span>
										<strong className="dashboard-info-text">{provideIntlService(this).formatDate(new Date(this.props.accountDetails.selectedMember.lastRenewDate), 'MM/d/y')}</strong>
									</p>
								</li>
								<li sm={{ size: 6, order: 2, offset: 1 }} className="list-group-item">
									<p>
										<span className="pr-2">Next Renew Date: </span>
										<strong className="dashboard-info-text">{provideIntlService(this).formatDate(new Date(this.props.accountDetails.selectedMember.nextRenewDate), 'MM/d/y')}</strong>
									</p>
								</li>

								<li sm={{ size: 6, order: 2, offset: 1 }} className="list-group-item">
									<p>
										<span className="pr-2">Assigned To User: </span>
										<strong className="dashboard-info-text">{this.props.accountDetails.selectedMember.fullName ? this.props.accountDetails.selectedMember.fullName : 'Unassigned'}</strong>
									</p>
								</li>
							</ul>
						</div>
					</div>

				{ this.state.isOwner ? <div>
						<div>
							<h2 className="pt-3 pb-3">Payment Info</h2>
						</div>
						<div className="card">
							<ul className="list-group list-group-flush dashboard-info-list">
								<li className="list-group-item">
								{
									this.state.paymentDetailsLoading
										? <SpanSpinner message="Loading..." />
										: <button
											className="btnPrimary btn btn-primary"
											type="button"
											onClick={() => this.setState({ isPopupVisible: true })}
										>PAY DUES / UPDATE MEMBERSHIP PACKAGE</button>
								}
								</li>
							</ul>
							<PaymentDetails
								isPopupVisible={this.state.isPopupVisible}
								membershipDetails={this.membership}
								membershipId={this.props.accountDetails.selectedMember.membershipId}
								close={this.close}
								paymentMethod={this.props.paymentMethod}
							/>
						</div>
					</div> : null }

					{/*
						this.state.isOwner ?
						<div>
							<div>
								<h2 className="pt-3 pb-3">Subscription Details</h2>
							</div>
							{this.props.accountDetails.selectedMember &&
								<SubscriptionDetails
									membershipId={this.props.accountDetails.selectedMember.membershipId}
								/>
							}
						</div>
						:
						''
					*/}
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		details: state.accountDetails.details,
		getting: state.accountDetails.getting,
		memberships: state.accountDetails.myMemberships,
		accountDetails: state.accountDetails,
		common: state.common,
		paymentMethod: state.accountDetails.paymentMethod, 
	};
}

export default withRouter(
	connect(mapStateToProps, {
		getAccountDetails,
		getMyMemberships,
		getPaymentMethod,
		clearPayment,
	})(MembershipDetails)
);
